<template>
  <f7-list inline-labels>
    <f7-list-item title="项目经理">
      <f7-icon icon="icon" slot="media"></f7-icon>
      <div slot="after">{{ manager.pm.map(item => item.name).join(', ') }}</div>
    </f7-list-item>
    <f7-list-item title="项目副经理">
      <f7-icon icon="icon" slot="media"></f7-icon>
      <div slot="after">{{ manager.dpm.map(item => item.name).join(', ') }}</div>
    </f7-list-item>
    <f7-list-item title="技术负责人">
      <f7-icon icon="icon" slot="media"></f7-icon>
      <div slot="after">{{ manager.techLeader.map(item => item.name).join(', ') }}</div>
    </f7-list-item>
    <f7-list-item title="专业工长">
      <f7-icon icon="icon" slot="media"></f7-icon>
      <div slot="after">{{ manager.professionLeader.map(item => item.name).join(', ') }}</div>
    </f7-list-item>
    <f7-list-item title="质量员">
      <f7-icon icon="icon" slot="media"></f7-icon>
      <div slot="after">{{ manager.qualityInspector.map(item => item.name).join(', ') }}</div>
    </f7-list-item>
    <f7-list-item title="安全员">
      <f7-icon icon="icon" slot="media"></f7-icon>
      <div slot="after">{{ manager.safeInspector.map(item => item.name).join(', ') }}</div>
    </f7-list-item>
    <f7-list-item title="预算员">
      <f7-icon icon="icon" slot="media"></f7-icon>
      <div slot="after">{{ manager.forecastInspector.map(item => item.name).join(', ') }}</div>
    </f7-list-item>
    <f7-list-item title="项目管理员">
      <f7-icon icon="icon" slot="media"></f7-icon>
      <div slot="after">{{ manager.projectAdmin.map(item => item.name).join(', ') }}</div>
    </f7-list-item>
    <f7-list-item title="其他相关人员">
      <f7-icon icon="icon" slot="media"></f7-icon>
      <div slot="after">{{ manager.relatPerson.map(item => item.name).join(', ') }}</div>
    </f7-list-item>
  </f7-list>
</template>
<script>

export default {
  props: ['projectId', 'manager'],
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ManagerView.vue